export const LogsTypes = {
  IListLogsService: Symbol("IListLogsService"),
};
